export default "__VITE_ASSET__CRccxlwh__"